/**
 * Derive responsive image variant URLs from a base image URL.
 * Convention: items-123.webp → items-123-thumb.webp, items-123-medium.webp
 */
export function getImageVariants(url) {
  if (!url || !url.endsWith('.webp')) return { thumb: url, medium: url, full: url };
  const stem = url.slice(0, -5);
  return {
    thumb: `${stem}-thumb.webp`,
    medium: `${stem}-medium.webp`,
    full: url,
  };
}

/**
 * Build a srcSet string for an image URL.
 * Returns empty string if url is falsy or not a .webp R2 image.
 */
export function buildSrcSet(url) {
  if (!url || !url.endsWith('.webp')) return '';
  const { thumb, medium, full } = getImageVariants(url);
  return `${thumb} 128w, ${medium} 256w, ${full} 600w`;
}
